import { render, staticRenderFns } from "./reminder-block-header.vue?vue&type=template&id=4415837e&scoped=true&"
import script from "./reminder-block-header.vue?vue&type=script&lang=js&"
export * from "./reminder-block-header.vue?vue&type=script&lang=js&"
import style0 from "./reminder-block-header.vue?vue&type=style&index=0&id=4415837e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4415837e",
  null
  
)

export default component.exports